import { useEffect, useState } from 'react';
import { brandingService } from '../services/brandingService';
import BrandMark from './BrandMark';

let logoRequest: Promise<string | null> | null = null;

function loadLogoUrl(): Promise<string | null> {
  if (!logoRequest) {
    logoRequest = brandingService
      .get()
      .then((branding) => branding.logoUrl)
      .catch(() => null);
  }
  return logoRequest;
}

/** Organization logo from Product Hub, with the product mark when none is set. */
const OrganizationMark = ({ size = 32 }: { size?: number }) => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    loadLogoUrl().then((url) => {
      if (active) setLogoUrl(url);
    });
    return () => {
      active = false;
    };
  }, []);

  if (!logoUrl || failed) return <BrandMark size={size} />;

  return (
    <img
      src={logoUrl}
      alt=""
      width={size}
      height={size}
      onError={() => setFailed(true)}
      className="rounded-control object-contain bg-white shrink-0"
    />
  );
};

export default OrganizationMark;
